import React from "react";
import styles from "./Header.module.css";
import LoginPart from "./LoginPart";
import LogoPart from "./LogoPart";
const TRACKING_ID = process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID as string;

// Only load features from Header, but not reloading the page
interface HeaderProps {
  disableSearch?: boolean;
}
const Header: React.FC<HeaderProps> = ({
  disableSearch = false
}) => {
  return <div className={styles.header} data-sentry-component="Header" data-sentry-source-file="Header.tsx">
			<LogoPart disableSearch={disableSearch} data-sentry-element="LogoPart" data-sentry-source-file="Header.tsx" />

			<LoginPart data-sentry-element="LoginPart" data-sentry-source-file="Header.tsx" />
		</div>;
};
export default Header;